// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3zEAi","right":"Footer_right__2cXAK","buttons":"Footer_buttons__rovjq"};